module.exports = __webpack_public_path__ + "static/media/rewards.5b0d1525.svg";